var map = {
	"./05-img.jpg": 6730,
	"./06-img.jpg": 4773,
	"./07-img.jpg": 208,
	"./08-img.jpg": 6323,
	"./09-img.jpg": 4654,
	"./10-img.jpg": 776,
	"./11-img.jpg": 5085,
	"./12-img.jpg": 690,
	"./13-img.jpg": 3623,
	"./blog-page-1.jpg": 7599,
	"./blog-page-2.jpg": 3984,
	"./blog-page-3.jpg": 3213,
	"./blog-page-4.jpg": 1750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8245;